import { atom } from "jotai";

export const zoomAtom = atom(2);

export const panAtom = atom({ x: 0, y: 0 });

export const isTwoFingerGestureAtom = atom(false);
